import { useTheme } from "../contexts/ThemeContext";
import { useSettings } from "../contexts/SettingsContext";
import { COLORS } from "../constants/colors";

export const useEffectiveTheme = () => {
  const { theme, colors } = useTheme();
  const { customPrimaryColor } = useSettings();

  // Get the default primary color for the current theme
  const getDefaultPrimaryColor = () => {
    return theme === "dark" ? COLORS.BLUE[400] : COLORS.BLUE[600];
  };

  // Return the effective colors with custom primary color override
  const effectiveColors = {
    ...colors,
    primary: customPrimaryColor || colors.primary,
  };

  return {
    theme,
    colors: effectiveColors,
    defaultPrimaryColor: getDefaultPrimaryColor(),
    customPrimaryColor,
  };
};
